import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
// import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
 
const Winning = ()=>{
    const [winning, setWinning] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [total, setTotal] = useState(0);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`winning?page=${page}`);
            setWinning(data.data);
            setLastPage(data.meta.last_page);
            setTotal(data.meta.total);

        }
        )();
    },[page]);
    // const del = async (id) =>{
    //     if(window.confirm("Are you sure you want to delete this record?")){
    //         await axios.delete(`winning/${id}`);
    //         setWinning(winning.filter((winning) => winning.id !== id));
    //     }
    // }
    return (
        <Wrapper pageTitle={'Winnings'}>
            <div className="w-full overflow-x-auto bg-white text-right leading-10 text-purple-700 pr-2">  Page <span className="rounded-full bg-purple-700 text-white p-2">{page}</span>/{lastPage} Total Records: {total} </div>
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">

                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">TimeIn </th>
                                    <th className="px-4 py-3">TheBio </th>
                                    <th className="px-4 py-3">TrxCode </th>
                                    <th className="px-4 py-3">Amount </th>
                                    <th className="px-4 py-3">Msisdn </th>
                                     
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {winning.map((winning)=>{
                                         return(
                                             <tr key={winning.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{winning.id}</td>
                                                 <td className="px-4 py-3 text-sm">{winning.time_in}</td>
                                                 <td className="px-4 py-3 text-sm">{winning.the_bio}</td>
                                                 <td className="px-4 py-3 text-sm">{winning.trx_code}</td>
                                                 <td className="px-4 py-3 text-sm">{winning.amount}</td>
                                                 <td className="px-4 py-3 text-sm">{winning.msisdn}</td>
                                                
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default Winning;